import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen } from '@fortawesome/pro-regular-svg-icons'
import {
  ButtonV2,
  StatusBarColorsV4,
  StatusBarV4,
  VerticalDivider,
} from '@labrav/react-components'
import { makeStyles } from 'tss-react/mui'
import {
  resolveRenewalBanner,
  type RenewalDetailsLike,
} from '../../utils/renewalDetailsFormat'
import { UpliftPercentageModal } from '../UpliftPercentageModal/UpliftPercentageModal'

const useStyles = makeStyles()(theme => ({
  row: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  update: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
  },
}))

export const RenewalDetailsBanners = ({
  item,
  endIso,
  timeZone,
  onSubmitUplift,
}: {
  item: RenewalDetailsLike
  endIso?: string
  timeZone: string
  onSubmitUplift?: (percent: number) => void
}) => {
  const { classes } = useStyles()
  const [modalOpen, setModalOpen] = useState(false)
  const banner = resolveRenewalBanner(item, endIso, timeZone)
  if (!banner) return null

  const content =
    banner.kind === 'updateUplift' ? (
      <div className={classes.row} data-testid="renewal-banner-update-uplift">
        <div>
          Update the final uplift percentage before the {banner.dateLabel}.
          Otherwise, the default uplift percentage will be applied.
        </div>
        <div className={classes.update}>
          <VerticalDivider height="20px" />
          <ButtonV2
            styleType="link"
            data-testid="renewal-banner-update"
            icon={
              <FontAwesomeIcon
                icon={faPen}
                style={{ width: '16px', height: '16px' }}
              />
            }
            onClick={() => setModalOpen(true)}
          >
            Update
          </ButtonV2>
        </div>
      </div>
    ) : banner.kind === 'optOutPassed' ? (
      <div data-testid="renewal-banner-opt-out-passed">
        The buyer can no longer opt out of the renewal contract.
      </div>
    ) : (
      <div data-testid="renewal-banner-opt-out-upcoming">
        Buyer cannot opt out of renewal contract after {banner.dateLabel}.
      </div>
    )

  return (
    <div data-testid="renewal-details-banner">
      <StatusBarV4
        backgroundColor={
          banner.kind === 'updateUplift'
            ? StatusBarColorsV4.YELLOW
            : StatusBarColorsV4.LIGHTBLUE
        }
        divider={banner.kind === 'updateUplift'}
        content={content}
      />
      {banner.kind === 'updateUplift' && (
        <UpliftPercentageModal
          open={modalOpen}
          minPercent={item.priceUpliftMinPercent}
          maxPercent={item.priceUpliftMaxPercent}
          initialPercent={item.enteredUpliftPercent}
          onClose={() => setModalOpen(false)}
          onSubmit={percent => {
            onSubmitUplift?.(percent)
            setModalOpen(false)
          }}
        />
      )}
    </div>
  )
}
